export { default as ResponsiveVadImage } from './ResponsiveVadImage';
